import React, { useEffect } from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import { ContractBenefitCategory } from 'types/contracts';

import ShopDataModalContractBenefitsCategory from './ShopDataModalContractBenefitsCategory';
import ShopDataModalCategoryHeader from '../common/ShopDataModalCategoryHeader';
import { FIELD_CATEGORY, SHOP_DATA_TABS_GENERAL_KEY } from '../constants';
import { flattenContractBenefits, getContractBenefitsMenuItems, normalizeContractBenefits } from '../helpers';
import { useShopDataModalContext } from '../ShopDataModalContext';

const Container = styled.div`
  display: flex;
  flex-flow: column;
`;

type Props = {
  step: number;
};

const ShopDataModalContractBenefits = ({ step }: Props) => {
  const {
    form,
    currentTab,
    community,
    currentData,
    disabled,
    isCommunityCcrc,
    setCurrentData,
    handleDataStatusChanged,
  } = useShopDataModalContext();

  const showContractBenefits =
    isCommunityCcrc &&
    currentTab === SHOP_DATA_TABS_GENERAL_KEY &&
    community?.contracts?.length &&
    community?.contracts?.length > 0;

  const contractBenefitItems = showContractBenefits ? getContractBenefitsMenuItems(community?.contracts ?? []) : [];

  const selectedContractStep = contractBenefitItems.find((benefit) => benefit.step === step);

  const contractId = selectedContractStep?.contract_id;

  if (!selectedContractStep || !contractId) return null;

  const benefitDataRaw = currentData[FIELD_CATEGORY.CONTRACT_BENEFITS]?.[contractId] || [];
  const groupedBenefitData = normalizeContractBenefits(benefitDataRaw);

  const initialValues = {
    [FIELD_CATEGORY.CONTRACT_BENEFITS]: {
      [contractId]: groupedBenefitData,
    },
  };

  useEffect(() => {
    if (contractId && benefitDataRaw) {
      form?.setFieldsValue({
        [FIELD_CATEGORY.CONTRACT_BENEFITS]: {
          [contractId]: groupedBenefitData,
        },
      });
    }
  }, [contractId, benefitDataRaw, form]);

  const handleValuesChange = () => {
    const formDataGrouped = form?.getFieldValue(FIELD_CATEGORY.CONTRACT_BENEFITS);
    const formDataFlat = flattenContractBenefits(formDataGrouped?.[contractId]);

    setCurrentData((prev: any) => ({
      ...prev,
      [FIELD_CATEGORY.CONTRACT_BENEFITS]: {
        ...prev[FIELD_CATEGORY.CONTRACT_BENEFITS],
        [contractId]: formDataFlat,
      },
    }));

    handleDataStatusChanged([FIELD_CATEGORY.CONTRACT_BENEFITS]);
  };

  return (
    <Container>
      <Form form={form} initialValues={initialValues} disabled={disabled} onValuesChange={handleValuesChange}>
        <ShopDataModalCategoryHeader label={`${selectedContractStep.label} · Benefits`} />

        {currentData?.contractBenefitCategories?.map((category: ContractBenefitCategory) => (
          <ShopDataModalContractBenefitsCategory
            key={category.id}
            category={category}
            contractId={contractId}
            communityId={community?.id}
            disabled={disabled}
          />
        ))}
      </Form>
    </Container>
  );
};

export default ShopDataModalContractBenefits;
